//STYLES
import "./index.css"
import { RotatingLines } from "react-loader-spinner"

export default function PreLoader({
    width = "50",
}: {
    width?: string
}): JSX.Element {
    return (
        <div id="preloader" className="flex justify-center items-center">
            {/* <div id="loader"></div> */}
            <RotatingLines
                visible={true}
                width={width}
                strokeWidth="3"
                animationDuration="0.75"
                strokeColor="#ff8c3f"
            />
        </div>
    )
}
